import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import Headline from '../../ui/Headline';
import { useTranslation } from 'react-i18next';
import QrCode from '../../ui/QRcode';
const ShareQR = ({ url, alert, description = 'admin.share_rally_description', title = 'admin.share_rally_title', }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: 'share-qr', children: [_jsx("div", { className: "share-qr-title", children: _jsx(Headline, { title: t(title), type: 'h1' }) }), _jsx(QrCode, { url: url, title: description, alert: alert })] }));
};
export default ShareQR;
